import React from 'react';
import PropTypes from 'prop-types';


class VideoContent extends React.Component {
  parseSrc() {
    const { src } = this.props;

    if (src.includes('https://www.youtube.com/watch?v=')) {
      return src.replace('https://www.youtube.com/watch?v=', 'https://www.youtube.com/embed/');
    }
    return src;
  }

  render() {
    const { title, src } = this.props;
    const isIframe = src.includes('youtube');
    return (
      <div className="c-video-content">
        <h2 className="video-title">{title}</h2>
        <div className="video">
          {isIframe ?
            <iframe width="420" height="315" src={this.parseSrc()} frameBorder="0" allowFullScreen></iframe> :
            <video width="400" controls autoPlay controls="controls">
              <source src={src} type="video/mp4" />
              <source src={src} type="video/ogg" />
              Your browser does not support HTML5 video.
            </video>
          }
        </div>
      </div>
    );
  }
}

VideoContent.propTypes = {
  title: PropTypes.string,
  src: PropTypes.string
};

export default VideoContent;



// WEBPACK FOOTER //
// ./app/components/common/modals/VideoContent.jsx